const translations = {
    addFarm: 'Add Farm'
};

export default translations;
